export default __webpack_public_path__ + "static/media/van@2x.8645db84.png";